import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import ShiftService from '@/modules/shifts/ShiftService';
var shift = {
  start_at: '0:00',
  end_at: '0:00',
  order_per_shift: '',
  days_closed: []
};

var ShiftModel =
/** @class */
function (_super) {
  __extends(ShiftModel, _super);

  function ShiftModel() {
    var _this = _super.call(this, shift, ShiftService) || this;

    _this.modelName = 'Turno';
    _this.request = 'JSON';
    return _this;
  }

  ShiftModel.prototype.getShiftsByDate = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , ShiftService.getShiftsByDate(__assign({
              method: 'GET'
            }, query))];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total
              }];
            }

            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  return ShiftModel;
}(BaseModel);

export default ShiftModel;